import React from 'react';

import './style.sass';

const BigImgScroll = ({ img }) => {
    return (
        <div className="big-img-scroll__wrapper">
            <div className="big-img-scroll__img">
                <img src={img} alt="" loading="lazy" />
            </div>
        </div>
    );
};

export default BigImgScroll;
